import React, { FC } from 'react';
import { components, OptionProps } from 'react-select';

export type OptionType = FC<OptionProps<any>>;

export const Option: OptionType = React.memo(props => {
  const { data, innerProps, selectOption } = props;
  const { custom, CustomComponent } = data;

  return custom && CustomComponent ? (
    CustomComponent && (
      <CustomComponent selectOption={selectOption} {...innerProps} />
    )
  ) : (
    <components.Option {...props} />
  );
});

Option.displayName = 'Option';
